import { Head } from "@inertiajs/react";
import AuthLayout from "../layouts/AuthLayout";
import { InertiaPageComponent } from "@/types";
import type { TrackEvent, LapData, Comment, GearItem } from "@/types/generated";
import LapChart from "../../frontend/components/LapChart";
import { EventHeaderCard } from "../components/track-event/event-header-card";
import { SessionDetailsCard } from "../components/track-event/session-details-card";
import { RaceCommentaryCard } from "../components/track-event/race-commentary-card";
import { GenerateCommentaryCard } from "../components/track-event/generate-commentary-card";
import { LapTimesTable } from "../components/track-event/lap-times-table";
import { EventCommentsCard } from "../components/track-event/event-comments-card";
import { EventFilesUploaderCard } from "../components/track-event/event-files-uploader-card";
import { UploadedFilesCard } from "../components/track-event/uploaded-files-card";

interface TrackEventLapsPageProps {
  track_event: TrackEvent;
  lap_data: LapData[];
  comments: Comment[];
  available_gear: GearItem[];
}

const TrackEventLaps: InertiaPageComponent<TrackEventLapsPageProps> = ({
  track_event,
  lap_data,
  comments,
  available_gear,
}) => {
  return (
    <>
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <EventHeaderCard
          trackEvent={track_event}
          availableGear={available_gear}
        />
        <SessionDetailsCard trackEvent={track_event} />
        <RaceCommentaryCard trackEvent={track_event} />
        <GenerateCommentaryCard trackEvent={track_event} />
        {track_event.session_type === "race" && (
          <div className="mb-6">
            <LapChart trackEventId={track_event.id} />
          </div>
        )}
        <LapTimesTable trackEvent={track_event} lapData={lap_data} />
        <EventCommentsCard trackEventId={track_event.id} comments={comments} />
        <EventFilesUploaderCard trackEvent={track_event} />
        <UploadedFilesCard trackEvent={track_event} />
      </main>
    </>
  );
};

TrackEventLaps.layout = (page) => <AuthLayout>{page}</AuthLayout>;

export default TrackEventLaps;
